// Module
var code = "<textarea data-ui-codemirror=\"\" data-ui-codemirror-opts=\"\n          { mode: 'text/css',\n            lineNumbers: true,\n            lineWrapping: true,\n            matchBrackets: true,\n            autoMatchParens: true,\n            autoClearEmptyLines: true\n          } \">\n</textarea> ";
// Exports
var _module_exports =code;;
var path = 'common/vngageCodemirrorLess/vngageCodemirrorLessTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;